import { FC, useCallback } from 'react';

import { RoundedButton } from 'shared/components/UI/Buttons';

import { EDirection, IArrowControls } from './types';

import * as styles from './styles.css';

export const ArrowControls: FC<IArrowControls> = props => {
  const { isLeftButtonVisible = true, isRightButtonVisible = true, onButtonClick } = props;

  const handleButtonClick = useCallback(
    (direction: EDirection) => () => {
      const directionValue = direction === EDirection.LEFT ? -1 : 1;

      onButtonClick(directionValue);
    },
    [onButtonClick],
  );

  return (
    <>
      {isLeftButtonVisible && (
        <RoundedButton
          className={styles['left']}
          dataTestId="arrow-control-left"
          onClick={handleButtonClick(EDirection.LEFT)}
        />
      )}
      {isRightButtonVisible && (
        <RoundedButton
          right
          className={styles['right']}
          dataTestId="arrow-control-right"
          onClick={handleButtonClick(EDirection.RIGHT)}
        />
      )}
    </>
  );
};
